export default {"src":"/_next/static/image/public/images/flags/flag_235.dc32167b0fe21d0089649cc41b3b2196.svg","height":16,"width":24};